import _ from 'lodash';
import { linkService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM,
    ADD_LINK_TYPE,
    REMOVE_LINK_TYPE,
    ADD_APPLICATION,
    REMOVE_APPLICATION,
    ADD_IT_SERVICE,
    REMOVE_IT_SERVICE,
    ADD_PROGRAM,
    REMOVE_PROGRAM,
    ADD_IDEA,
    REMOVE_IDEA,
    ADD_PROJECT,
    REMOVE_PROJECT
} from "./mutations.type";


function getBlankLink() {
    return {
        linkId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        accountLinkNumber: null,
        name: "",
        websiteAddress: "",
        notes: "",
        displayOrder: 0,
        active: true,
        deleted: false,
        createdDate: null,
        createdBy: null,
        createdByName: null,
        modifiedDate: null,
        modifiedBy: null,
        modifiedByName: null,
        linkTypes: [],
        typesDescription: null,
        applicationLinks: [],
        itServiceLinks: [],
        ideaLinks: [],
        programLinks: [],
        projectLinks: []
    };
}

function getBlankApplicationLink() {
    return {
        applicationLinkId: GUID_EMPTY,
        applicationId: GUID_EMPTY,
        name: null
    };
}

function getBlankITServiceLink() {
    return {
        itServiceLinkId: GUID_EMPTY,
        itServiceId: GUID_EMPTY,
        name: null
    };
}

function getBlankIdeaLink() {
    return {
        ideaLinkId: GUID_EMPTY,
        ideaId: GUID_EMPTY,
        name: null
    };
}

function getBlankProgramLink() {
    return {
        programLinkId: GUID_EMPTY,
        programId: GUID_EMPTY,
        name: null
    };
}

function getBlankProjectLink() {
    return {
        projectLinkId: GUID_EMPTY,
        projectId: GUID_EMPTY,
        name: null
    };
}

function getBlankLinkType() {
    return {
        linkTypeId: GUID_EMPTY,
        linkId: GUID_EMPTY,
        refLinkTypeId: GUID_EMPTY,
        name: null,
    };
}

export const links = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentLink: getBlankLink()
    },
    getters: {
        getAccountLinks: (state) => (id) => {
            return state.items.filter(item => item.accountId != null);
        },
        getGlobalLinks: (state) => (id) => {
            return state.items.filter(item => item.accountId == null);
        },
    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                linkService.getAll()
                    .then(
                        links => {
                            commit(GET_ALL_SUCCESS, links);
                            resolve(links);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, linkId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return linkService.getById(linkId)
                    .then(
                        link => {
                            commit(GET_BY_ID_SUCCESS, link);
                            resolve(link);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, link) {
            return linkService.add(link);
        },
        [UPDATE]({ dispatch, commit }, link) {
            return linkService.update(link);
        },
        [DELETE]({ dispatch, commit }, link) {
            return linkService.deleteLink(link);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, links) {
            state.status = { loaded: true };
            state.items = links;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, link) {
            state.status = { loaded: true };
            state.currentLink = link;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentLink = getBlankLink();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentLink = getBlankLink();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentLink, {
                [field]: value
            });
        },

        [ADD_LINK_TYPE](state, linkType) {
            var newRecord = getBlankLinkType();
            newRecord.refLinkTypeId = linkType.refLinkTypeId;
            newRecord.name = linkType.name;
            state.currentLink.linkTypes.push(newRecord);
        },
        [REMOVE_LINK_TYPE](state, refLinkTypeId) {
            let arr = state.currentLink.linkTypes;
            arr.splice(arr.findIndex(item => item.refLinkTypeId === refLinkTypeId), 1)
        },

        [ADD_APPLICATION](state, application) {
            var link = getBlankApplicationLink();
            link.applicationId = application.applicationId;
            link.name = application.name;
            state.currentLink.applicationLinks.push(link);
        },
        [REMOVE_APPLICATION](state, applicationId) {
            let index = _.findIndex(state.currentLink.applicationLinks, { 'applicationId': applicationId });
            if (index > -1) {
                state.currentLink.applicationLinks.splice(index, 1);
            }
        },

        [ADD_IT_SERVICE](state, itService) {
            var link = getBlankITServiceLink();
            link.itServiceId = itService.itServiceId;
            link.name = itService.name;
            state.currentLink.itServiceLinks.push(link);
        },
        [REMOVE_IT_SERVICE](state, itServiceId) {
            let index = _.findIndex(state.currentLink.itServiceLinks, { 'itServiceId': itServiceId });
            if (index > -1) {
                state.currentLink.itServiceLinks.splice(index, 1);
            }
        },
        
        [ADD_IDEA](state, idea) {
            var link = getBlankIdeaLink();
            link.ideaId = idea.ideaId;
            link.name = idea.name;
            state.currentLink.ideaLinks.push(link);
        },
        [REMOVE_IDEA](state, ideaId) {
            let index = _.findIndex(state.currentLink.ideaLinks, { 'ideaId': ideaId });
            if (index > -1) {
                state.currentLink.ideaLinks.splice(index, 1);
            }
        },
        
        [ADD_PROGRAM](state, program) {
            var link = getBlankProgramLink();
            link.programId = program.programId;
            link.name = program.name;
            state.currentLink.programLinks.push(link);
        },
        [REMOVE_PROGRAM](state, programId) {
            let index = _.findIndex(state.currentLink.programLinks, { 'programId': programId });
            if (index > -1) {
                state.currentLink.programLinks.splice(index, 1);
            }
        },
        
        [ADD_PROJECT](state, project) {
            var link = getBlankProjectLink();
            link.projectId = project.projectId;
            link.name = project.name;
            state.currentLink.projectLinks.push(link);
        },
        [REMOVE_PROJECT](state, projectId) {
            let index = _.findIndex(state.currentLink.projectLinks, { 'projectId': projectId });
            if (index > -1) {
                state.currentLink.projectLinks.splice(index, 1);
            }
        }


    }
}
